<template>
  <div class="c-service-logo">
    <img
      :src="serviceLogo"
      :alt="serviceName"
      class="c-service-logo__img"
      v-if="serviceLogo"
    />
  </div>
</template>

<script>
import commons from "@/common/store/modules/commons";
import { Options, Vue } from 'vue-class-component';
import { mapState } from "vuex";
import AuthApi from "@/general/api/authApi";

@Options({
  computed: {
    ...mapState({
      //#59042対応によりセッション情報からpage_logoを取得するように修正
      //serviceLogo: () => commons.serviceLogo,
      serviceLogo: () => this.service_logo,
      serviceName: () => commons.serviceName
    })
  }
})
export default class ServiceLogo extends Vue {

  service_logo = "";

  //#59042対応によりセッション情報からpage_logoを取得するように修正
  async created() {
    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.service_logo = ic_session.pageLogo;
    })
    .catch(() => {
      this.service_logo = "";
    });
  }
}
</script>

<style lang="scss" scoped>
.c-service-logo {
  &__img {
    display: block;
  }
}
</style>
